module.exports = __webpack_public_path__ + "img/facebook.ca2ac008.svg";